class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }


  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    event.target.closest('details').classList.add("active")

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
      setTimeout(() => {
       this.detailsContainer.removeAttribute('open');
      }, 500);
    this.detailsContainer.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);


const modal = document.querySelector('details-modal');
const bottomSearchIcon = document.querySelector("#bottom-search-icon");

if (bottomSearchIcon) {
  bottomSearchIcon.addEventListener("click", function() {
    const details = modal.detailsContainer;
    if (details) {
      details.classList.add("active");
      details.setAttribute("open", "true");
      document.body.classList.add('overflow-hidden');
      const input = details.querySelector('.search__input.field__input');
      // if (input) {
      //   input.focus();
      // }
      modal.onBodyClickEvent = modal.onBodyClickEvent || modal.onBodyClick.bind(modal);
      setTimeout(() => {
        document.body.addEventListener('click', modal.onBodyClickEvent);
      }, 0);
    }
  });
}